import React, { Component, PropTypes } from 'react'
import qs from 'qs'
import { Half } from 'grid-styled'
import styled from 'styled-components'
import { translate } from 'react-i18next'
import { Fonts, Metrics, Colors } from '../../Themes'
import AuthActions from '../../actions/AuthActions'
import Input from '../../components/Input'
import Button from '../../components/Button'
import config from '../../config'
import Modal from '../../components/Modal'
import linkedinButton from '../../../public/img/Button/linkedin.png'
import AuthStore from '../../stores/AuthStore'
import { errorMessages } from '../../Utils/ErrorMessages'
import { resendCode, loginUser } from '../../sources/AuthSources'

const Container = styled.div``

const CustomInput = styled(Input)`
  margin-bottom: ${Metrics.margins.base};

  .inputTitle {
    color: ${Colors.primary};
  }
`

const Error = styled.div`
  margin-top: ${Metrics.margins.tiny};
  margin-bottom: ${Metrics.margins.small};
  ${Fonts.style.Input};
  color: ${Colors.red};
`

const Links = styled.div`
  ${Fonts.style.Small};

  div {
    margin-bottom: ${Metrics.margins.tiny};
    span {
      cursor: pointer;
    }
  }
`

const Buttons = styled.div`
  margin-top: ${Metrics.margins.larger};

  button {
    float: right;
    &.linkedin {
      float: left;
      background: url('${linkedinButton}') no-repeat center;
      padding: 0;
      height: 32px;
      border: 0px;
      width: 175px;
      background-size: cover;
      border-radius: 0;
      float: left;
    }
  }

  .left {
    float: left;
  }

  @media screen and (max-width: ${Metrics.breakpoints.mobile}){
    .left {
      float: none;
    }

    button {
      float: none;
      margin-bottom: ${Metrics.margins.base};
      &.linkedin {
        float: none;
      }
    }
  }
`

const Text = styled.div`
  ${Fonts.style.Text};
  margin-top: -${Metrics.margins.base};
  margin-bottom: ${Metrics.margins.base};
`

const CustomHalf = styled(Half)`
  padding: 0 ${Metrics.margins.medium};
`

class Login extends Component {
  constructor (props) {
    super(props)
    this.state = {
      email: '',
      password: '',
      code: '',
      id: ''
    }

    this.handleEmailChange = this.handleEmailChange.bind(this)
    this.handlePasswordChange = this.handlePasswordChange.bind(this)
    this.handleCodeChange = this.handleCodeChange.bind(this)
    this.handleLogin = this.handleLogin.bind(this)
    this.linkedinLogin = this.linkedinLogin.bind(this)
    this.handleKeyPress = this.handleKeyPress.bind(this)
    this.handleValidateCode = this.handleValidateCode.bind(this)
    this.handleResendCode = this.handleResendCode.bind(this)
  }

  static getInitialState () {
    return AuthStore.getState()
  }

  static getStores () {
    return [ AuthStore ]
  }

  static getPropsFromStores () {
    return {
      errorMessage: AuthStore.getState().errorMessage
    }
  }

  componentWillUpdate (nextProps, nextState) {
    if (!this.props.errorMessage && nextProps.errorMessage) {
      const {
        firstName,
        lastName,
        email,
        linkedin,
        company,
        jobTitle,
        id
      } = this.props.location.query
      const linkedinError =
        nextProps.errorMessage === 'Your account is not activated' ||
        nextProps.errorMessage === 'Your account is not approved yet'
      if (email && !linkedinError) {
        this.props.router.push(
          `/landing/signup?id=${id}&email=${email}&firstName=${encodeURIComponent(
            firstName
          )}&lastName=${encodeURIComponent(
            lastName
          )}&linkedin=${linkedin}&company=${encodeURIComponent(
            company
          )}&jobTitle=${encodeURIComponent(jobTitle)}`
        )
      }
    }
  }

  componentWillMount () {
    const { email, id } = this.props.location.query

    if (email && email !== '') {
      loginUser({ email, linkedinId: id })
        .then(response => {
          if (email === config.DEMO_EMAIL) {
            AuthActions.loginSuccess(response.data)
          } else {
            this.setState({ id: response.data.id })
          }
        })
        .catch(error => {
          return error.response.status === 403
            ? AuthActions.loginFailed(error.response.data)
            : AuthActions.loginFailed(errorMessages.general)
        })
    }
  }

  handleCodeChange (event) {
    this.setState({ code: event.target.value })
  }

  handlePasswordChange (event) {
    this.setState({ password: event.target.value })
  }

  handleEmailChange (event) {
    this.setState({ email: event.target.value })
  }

  handleLogin () {
    const { email, password } = this.state
    if (email.length > 0 && password.length > 0) {
      loginUser({ email, password })
        .then(response => {
          if (email === config.DEMO_EMAIL) {
            AuthActions.loginSuccess(response.data)
          } else {
            this.setState({ id: response.data.id }, AuthActions.cleanError)
          }
        })
        .catch(error => {
          return error.response.status === 403
            ? AuthActions.loginFailed(error.response.data)
            : AuthActions.loginFailed(errorMessages.general)
        })
    }
  }

  handleResendCode () {
    resendCode(this.state.id)
  }

  handleValidateCode () {
    const { id, code } = this.state
    AuthActions.validateCode(id, code)
  }

  handleKeyPress (event) {
    const { code } = this.state
    if (event.key === 'Enter') {
      code ? this.handleValidateCode() : this.handleLogin()
    }
  }

  linkedinLogin () {
    window.location =
      'https://www.linkedin.com/oauth/v2/authorization?' +
      qs.stringify({
        client_id: config.Oauth2.clientId,
        redirect_uri: config.Oauth2.authCalbackURI,
        scope: config.Oauth2.scope,
        state: config.Oauth2.state,
        response_type: 'code'
      })
  }

  render () {
    const { errorMessage, t, router } = this.props
    const { email, password, code, id } = this.state

    return (
      <Modal
        visible
        header={t('Login')}
        closeAction={() => {
          router.replace('/landing')
        }}>
        {id ? (
          <Container>
            <Text>
              {t('Please insert the code that was sent to your number.')}
            </Text>
            <CustomInput
              value={code}
              title={'SMS Code'}
              type={code}
              handleChange={this.handleCodeChange}
            />
            {errorMessage && <Error>{t(errorMessage)}</Error>}
            <Buttons>
              <CustomHalf>
                <Button
                  label={'Enter'}
                  onClick={this.handleValidateCode}
                  handleKeyPress={this.handleKeyPress}
                />
              </CustomHalf>
              <CustomHalf>
                <Button
                  label={'Resend Code'}
                  onClick={this.handleResendCode}
                  secondary
                  className={'left'}
                />
              </CustomHalf>
            </Buttons>
          </Container>
        ) : (
          <Container>
            <CustomInput
              value={email}
              title={'E-mail'}
              type={'e-mail'}
              handleChange={this.handleEmailChange}
            />
            <CustomInput
              value={password}
              type={'password'}
              handleChange={this.handlePasswordChange}
              title={'Password'}
              handleKeyPress={this.handleKeyPress}
            />
            {errorMessage && <Error>{t(errorMessage)}</Error>}
            <Links>
              <div>
                {t('Become a Member?')}
                <span onClick={() => router.push('/landing/signup')}>
                  {'  ' + t('Click Here')}
                </span>
              </div>
              <div
                className={'reset'}
                onClick={() => router.push('/landing/reset')}>
                <span>{t('Reset Password')}</span>
              </div>
            </Links>
            <Buttons>
              <CustomHalf>
                <Button
                  disabled={!(email.length > 0) || !(password.length > 0)}
                  label={'Login'}
                  onClick={this.handleLogin}
                />
              </CustomHalf>
              <CustomHalf>
                <button onClick={this.linkedinLogin} className='linkedin' />
              </CustomHalf>
            </Buttons>
          </Container>
        )}
      </Modal>
    )
  }
}

Login.propTypes = {
  router: PropTypes.object,
  errorMessage: PropTypes.string,
  t: PropTypes.func,
  location: PropTypes.object
}

export default translate([ 'common', 'landing' ], { wait: true })(Login)



// WEBPACK FOOTER //
// ./src/pages/Landing/Login.js